import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setSingleQuiz, setLoading } from "../../repository/slice";

function* getSingleQuizWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/admin/questionnaires/" + payload.id);
        if (isError) {

        } else {
            yield put(setSingleQuiz(data));
        }
    } catch (error) {
        console.error("getSingleQuizWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getSingleQuizWatcher() {
    yield takeLatest("@saga/GET_SINGLE_QUIZ", getSingleQuizWorker);
};
